// extracted by mini-css-extract-plugin
export default {"wrapper":"modal-header_wrapper__pNmQZ","wrapper_end":"modal-header_wrapper_end__i7gvq","buttonClose":"modal-header_buttonClose__wPlpC"};